import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-de-confirmacao-de-cancelamento',
  templateUrl: './popup-de-confirmacao-de-cancelamento.component.html',
  styleUrls: ['./popup-de-confirmacao-de-cancelamento.component.css']
})
export class PopupDeConfirmacaoDeCancelamentoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
